import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { PrivateRadioOption } from './PrivateRadioOption';
import { PublicRadioOption } from './PublicRadioOption';
import { TeamRadioOption } from './TeamRadioOption';
import { TASK_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { TaskViewSharingEditor } from '../TaskViewSharingEditor';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ViewSharingEditor = ({
  originalView,
  viewUpdates,
  setViewUpdates
}) => {
  if (originalView.objectTypeId === TASK_TYPE_ID) {
    return /*#__PURE__*/_jsx(TaskViewSharingEditor, {
      originalView: originalView,
      viewUpdates: viewUpdates,
      setViewUpdates: setViewUpdates
    });
  }
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.modals.manageSharing.label"
    }),
    children: /*#__PURE__*/_jsxs(ToggleGroup, {
      name: "view-sharing-options",
      children: [/*#__PURE__*/_jsx(PrivateRadioOption, {
        viewUpdates: viewUpdates,
        setViewUpdates: setViewUpdates
      }), /*#__PURE__*/_jsx(TeamRadioOption, {
        originalView: originalView,
        viewUpdates: viewUpdates,
        setViewUpdates: setViewUpdates
      }), /*#__PURE__*/_jsx(PublicRadioOption, {
        viewUpdates: viewUpdates,
        setViewUpdates: setViewUpdates
      })]
    })
  });
};